import { getFeaturePermission, hasSubFeatureAccess } from '@zeta-commons';
import { IUserAccess } from '@zeta-core';
import {
  AdviceTemplatesNavIcon,
  BillingIcon,
  CertificationsNavIcon,
  ChangePasswordNavIcon,
  ChatBubbleOutlined,
  ClipboardCheckIcon,
  ClockRotateRight,
  CommunityIcon,
  CompanyBuildingIcon,
  DashboardSpeed,
  DocumentStarIcon,
  FactFindNavIcon,
  FeesAndChargesIcon,
  FinancialPlanningNavIcon,
  FirmProfileNavIcon,
  GraphUpIcon,
  HandCashIcon,
  HealthShieldIcon,
  HealthcareIcon,
  LotOfCashIcon,
  ManagePortfolioNavIcon,
  MessageTextIcon,
  MultiplePages,
  MyProfileNavIcon,
  NotesIcon,
  PageFlipIcon,
  // PhonePausedIcon,
  PiggyBankIcon,
  PrivacyPolicyIcon,
  ProductsNavIcon,
  RiskAssessmentNavIcon,
  SendPoundsIcon,
  SettingsContrastIcon,
  SleeperChairIcon,
  UserChat,
  UserIcon,
  UserNavIcon,
  UserSquareIcon,
  WalletIcon,
  WorkingHoursNavIcon,
} from '@zeta-core/assets';
import { RouterLinks } from '../../app-route-paths';
import { getClientFeatureAccess } from '../../helpers';

export const FACT_FIND_INDIVIDUAL_NAVIGATION = [
  {
    title: 'Documents',
    path: RouterLinks.factFindDocuments,
    icon: PageFlipIcon,
    hasBottomBorder: true,
    name: 'documents',
    id: 'documents',
  },
  {
    title: 'Overview',
    path: RouterLinks.factFindInitialMeetingSummary,
    icon: SettingsContrastIcon,
    name: 'overview',
    id: 'overview',
  },
  {
    title: 'Risk Assessment',
    path: RouterLinks.factFindRiskAssessment,
    icon: DashboardSpeed,
    name: 'riskAssessment',
    id: 'riskAssessment',
  },
  {
    title: 'Goals & Timeline',
    path: RouterLinks.factFindGoalsAndTimeline,
    icon: DashboardSpeed,
    name: 'goalsAndTimeline',
    id: 'goalsAndTimeline',
  },
  {
    title: 'About You',
    path: RouterLinks.factFindPersonalInfo,
    icon: UserIcon,
    name: 'personalInfo',
    id: 'personalInfo',
  },
  {
    title: 'Income',
    path: RouterLinks.factFindIncome,
    icon: PiggyBankIcon,
    name: 'income',
    id: 'income',
  },
  {
    title: 'Expenditure',
    path: RouterLinks.factFindExpenditure,
    icon: WalletIcon,
    name: 'expenditure',
    id: 'expenditure',
  },
  {
    title: 'Assets',
    path: RouterLinks.factFindAssets,
    icon: DocumentStarIcon,
    name: 'assets',
    id: 'assets',
  },
  {
    title: 'Liabilities',
    path: RouterLinks.factFindLiabilites,
    icon: SendPoundsIcon,
    name: 'liabilities',
    id: 'liabilities',
  },
  {
    title: 'Health Details',
    path: RouterLinks.factFindHealthDetails,
    icon: HealthShieldIcon,
    name: 'health',
    id: 'health',
  },
  {
    title: 'Nominees',
    path: RouterLinks.factFindBeneficiaries,
    icon: HandCashIcon,
    name: 'nominees',
    id: 'nominees',
  },
  {
    title: 'Benefits and Insurance',
    path: RouterLinks.factFindBenefitsAndInsurance,
    icon: HealthcareIcon,
    name: 'benefitsAndInsurance',
    id: 'benefitsAndInsurance',
  },
  // {
  //   title: 'Experience',
  //   path: RouterLinks.factFindExperience,
  //   icon: GoogleDocsIcon,
  // },
  { title: 'Financial Planning', path: RouterLinks.factFindFinancialPlanning, icon: LotOfCashIcon, name: 'financialPlanning', id: 'financialPlanning' },
  // {
  //   title: 'Protection Solution',
  //   path: RouterLinks.factFindProtectionSolution,
  //   icon: CardShieldIcon,
  // },
  // {
  //   title: 'Investment Solution',
  //   path: RouterLinks.factFindInvestmentSolution,
  //   icon: PuzzleIcon,
  // },
  { title: 'Summary and Notes', path: RouterLinks.factFindSummaryAndNotes, icon: NotesIcon, name: 'summary', id: 'summary' },
  // {
  //   title: 'Review',
  //   path: RouterLinks.factFindReview,
  //   icon: TaskListIcon,
  // },
  // {
  //   title: 'Fact Find Report',
  //   path: RouterLinks.factFindGenerateReport,
  //   icon: ReportsIcon,
  // },
];

export const FACT_FIND_BUSINESS_NAVIGATION = [
  { title: 'Documents', path: RouterLinks.factFindDocuments, icon: PageFlipIcon, hasBottomBorder: true, name: 'documents' },
  { title: 'Overview', path: RouterLinks.factFindInitialMeetingSummary, icon: MessageTextIcon, name: 'overview' },
  { title: 'Business Details', path: RouterLinks.factFindBusinessDetails, icon: CompanyBuildingIcon, name: 'businessDetails' },
  { title: 'Key Members', path: RouterLinks.factFindBusinessKeyMembers, icon: CommunityIcon, name: 'keyMembers' },
  { title: 'Financial Information', path: RouterLinks.factFindBusinessFinancialInformation, icon: SendPoundsIcon, name: 'financialInformation' },
  { title: 'Loans', path: RouterLinks.factFindBusinessLoans, icon: HandCashIcon, name: 'loans' },
  { title: 'Assets Premise', path: RouterLinks.factFindBusinessAssetsPremise, icon: DocumentStarIcon, name: 'assetsPremise' },
  { title: 'Professional Advisors', path: RouterLinks.factFindBusinessProfessionalAdvisors, icon: UserChat, name: 'professionalAdvisors' },
  { title: 'Pensions', path: RouterLinks.factFindBusinessPensions, icon: SleeperChairIcon, name: 'pensions' },
  { title: 'Covers', path: RouterLinks.factFindBusinessCovers, icon: PrivacyPolicyIcon, name: 'covers' },
  { title: 'Employee Benefits', path: RouterLinks.factFindBusinessEmployeeBenefits, icon: HealthcareIcon, name: 'employeeBenefits' },
  { title: 'Financial Planning', path: RouterLinks.factFindFinancialPlanning, icon: LotOfCashIcon, name: 'financialPlanning' },
  { title: 'Summary and Notes', path: RouterLinks.factFindSummaryAndNotes, icon: NotesIcon, name: 'summaryAndNotes' },
];

export const getFirmProfileNavigation = (userAccess: IUserAccess) => {
  return [
    {
      title: `Organisation`,
      icon: FirmProfileNavIcon,
      description: `Manage your firm's details, including address and logo.`,
      path: RouterLinks.organisationProfile,
      isEnabled: getFeaturePermission(userAccess?.access, 'AdvisorOrgConfig').accessible,
    },
    {
      title: `User Management`,
      icon: UserNavIcon,
      description: `Add, edit, or remove users and assign roles within your firm.`,
      path: RouterLinks.userManagement,
      isEnabled: hasSubFeatureAccess(userAccess?.access, 'AdvisorOrgConfig', 'UserManagement'),
    },
    {
      title: `Billing & Invoice`,
      icon: BillingIcon,
      description: `Manage your subscription and billing.`,
      path: RouterLinks.billingAndInvoice,
      isEnabled: hasSubFeatureAccess(userAccess?.access, 'AdvisorOrgConfig', 'BillingManagement'),
    },
    {
      title: `CRM`,
      icon: ProductsNavIcon,
      description: `Connect and manage your customer relationship management platforms.`,
      path: RouterLinks.crm,
      isEnabled: hasSubFeatureAccess(userAccess?.access, 'AdvisorOrgConfig', 'Products'),
    },
    {
      title: `Portfolios`,
      icon: ManagePortfolioNavIcon,
      description: `Manage your firm portfolios and allocation libraries.`,
      path: RouterLinks.modelPortfolios,
      isEnabled: getFeaturePermission(userAccess?.access, 'AdvisorOrgConfig').accessible,
    },
    {
      title: `Advice Templates`,
      icon: AdviceTemplatesNavIcon,
      description: `Manage and upload your firm's document templates for Fact Find and Suitability Reports, as well as other related settings.`,
      path: RouterLinks.adviceTemplates,
      isEnabled: getFeaturePermission(userAccess?.access, 'AdvisorOrgConfig').accessible,
    },
    {
      title: `Document Management`,
      icon: DocumentStarIcon,
      description: `Set up and customise the documents to incorporate into the process to ensure precise insights about your clients.`,
      path: RouterLinks.documentManagement,
      isEnabled: getFeaturePermission(userAccess?.access, 'AdvisorOrgConfig').accessible,
    },
    {
      title: `Client Communication`,
      icon: ChatBubbleOutlined,
      description: `Configure your firm's communication settings for client interactions.`,
      path: RouterLinks.clientCommunication,
      isEnabled: hasSubFeatureAccess(userAccess?.access, 'AdvisorOrgConfig', 'ClientCommunication'),
    },
  ];
};

export const MY_PROFILE_NAVIGATION = [
  {
    title: `My Profile`,
    icon: MyProfileNavIcon,
    description: `Update your personal information and preferences.`,
    path: RouterLinks.myProfile,
    isEnabled: true,
  },
  {
    title: `Meeting Configuration`,
    icon: WorkingHoursNavIcon,
    description: `Configure your calendar, including working hours, appointment availability, and holiday schedules.`,
    path: RouterLinks.meetingConfiguration,
    hide: true,
    isEnabled: true,
  },
  {
    title: `Change Password`,
    icon: ChangePasswordNavIcon,
    description: `You can change your password to ensure your account remains secure.`,
    path: RouterLinks.changePassword,
    isEnabled: true,
  },
];

export const MANAGED_CLIENT_NAVIGATION = (clientRegistered: boolean, planningStatus: string, userAccess: IUserAccess, clientCommunicationEnabled = false) => [
  {
    title: 'Portfolio Overview',
    path: RouterLinks.managedClientPortfolio,
    icon: GraphUpIcon,
    hasBottomBorder: true,
    show: getClientFeatureAccess(userAccess?.access, 'Advisor-Client-Portfolio', planningStatus).hasAccess,
  },
  {
    title: 'Client Information',
    icon: UserSquareIcon,
    children: [
      {
        title: 'Overview',
        path: RouterLinks.managedClientInitialMeetingSummary,
        icon: SettingsContrastIcon,
        hasBottomBorder: true,
        name: 'overview',
        id: 'overview',
      },
      { title: 'Risk Assessment', path: RouterLinks.managedClientRiskAssessment, icon: DashboardSpeed, name: 'riskAssessment', id: 'riskAssessment' },
      { title: 'About You', path: RouterLinks.managedClientPersonalInfo, icon: UserIcon, name: 'aboutYou', id: 'aboutYou' },
      { title: 'Income', path: RouterLinks.managedClientIncome, icon: PiggyBankIcon, name: 'income', id: 'income' },
      { title: 'Expenditure', path: RouterLinks.managedClientExpenditure, icon: WalletIcon, name: 'expenditure', id: 'expenditure' },
      { title: 'Assets', path: RouterLinks.managedClientAssets, icon: DocumentStarIcon, name: 'assets', id: 'assets' },
      { title: 'Liabilities', path: RouterLinks.managedClientLiabilites, icon: SendPoundsIcon, name: 'liabilities', id: 'liabilities' },
      { title: 'Health Details', path: RouterLinks.managedClientHealthDetails, icon: HealthShieldIcon, name: 'healthDetails', id: 'healthDetails' },
      { title: 'Nominees', path: RouterLinks.managedClientNominees, icon: HandCashIcon, name: 'nominees', id: 'nominees' },
    ],
    show: getClientFeatureAccess(userAccess?.access, 'Advisor-Client-FF', planningStatus).hasAccess,
  },
  {
    title: 'Financial Plans',
    icon: ClipboardCheckIcon,
    children: [
      {
        title: 'Protection Plan',
        path: RouterLinks.managedClientProtectionSolution,
        icon: HealthShieldIcon,
        name: 'protectionPlan',
        id: 'protectionPlan',
      },
      {
        title: 'Investment Plan',
        path: RouterLinks.managedClientInvestmentSolution,
        icon: PiggyBankIcon,
        name: 'investmentPlan',
        id: 'investmentPlan',
      },
    ],
    show: getClientFeatureAccess(userAccess?.access, 'Advisor-Client-FinancialPlan', planningStatus).hasAccess,
  },
  {
    title: 'Documents',
    path: RouterLinks.managedClientDocuments,
    icon: PageFlipIcon,
    hasBottomBorder: true,
    name: 'documents',
    id: 'documents',
    show: getClientFeatureAccess(userAccess?.access, 'SecureDocumentStorage', planningStatus).hasAccess,
  },
  {
    title: 'Secure Messages',
    icon: ChatBubbleOutlined,
    hasBottomBorder: true,
    name: 'secureMessages',
    id: 'secureMessages',
    path: RouterLinks.managedClientSecureMessage,
    show: clientCommunicationEnabled && getClientFeatureAccess(userAccess?.access, 'SecureMessaging', planningStatus).hasAccess,
    disabled: !clientRegistered,
    tooltip: 'This icon will be enabled after successful registration on the client portal.',
  },
  {
    title: 'Client Interactions',
    path: RouterLinks.managedClientInteractionHub,
    icon: ClockRotateRight,
    hasBottomBorder: true,
    name: 'clientInteractions',
    id: 'clientInteractions',
    show: true,
  },
  {
    title: 'Upcoming Actions',
    icon: MultiplePages,
    hasBottomBorder: true,
    name: 'upcomingActions',
    id: 'upcomingActions',
    show: true,
  },
];

export const DASHBOARD_CONFIG = { HEADER: { DESKTOP_HEIGHT: 64 }, NAVIGATION: { DESKTOP_WIDTH: 312 } };
